import { render, staticRenderFns } from "./ReportsTemplate.vue?vue&type=template&id=1cbe6704&scoped=true"
import script from "./ReportsTemplate.vue?vue&type=script&lang=ts"
export * from "./ReportsTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ReportsTemplate.vue?vue&type=style&index=0&id=1cbe6704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe6704",
  null
  
)

export default component.exports